import * as angular from "angular";
import {StudyUnitSelectorComponent} from "./study-unit-selector.component";
import {StudyUnitService} from "./study-unit.service";
import {ITemplateCacheService} from "angular";

export const StudyUnitModule = angular
    .module("app.shared.studyUnit", [])

    .service("studyUnitService", StudyUnitService)

    .component("studyUnitSelector", StudyUnitSelectorComponent)

    .run(($templateCache: ITemplateCacheService) => {
        $templateCache.put("study-unit-selector-item.html", require("./study-unit-selector-item.html"));
    })

    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/study-unit/study-unit.module.ts